import {client} from './client'
import Reel from '../models/reel'

export default {
  index (query) {
    return client.get('/reels', {
      params: query
    })
  },
  show (id) {
    return client.get('/reels/' + id + '?include=fund')
      .then((response) => {
        return new Reel(false, response.data.data)
      })
  },
  prev (id) {
    return client.get('/reels/' + id + '/prev?include=fund')
  },
  next (id) {
    return client.get('/reels/' + id + '/next?include=fund')
  },
  sequences (id, query) {
    return client.get('/reels/' + id + '/sequences', {
      params: query
    })
  },
  store (data) {
    return client.post('/reels', data.prepareForSend())
  },
  storeMassive (reel) {
    return client.post('/reels-store-massive', reel.prepareForSend())
  },
  updateMassive (massParam, massValue, massSelected) {
    return client.post('/reels-update-massive', {
      massParam: massParam,
      massValue: massValue,
      massSelected: massSelected
    })
  },
  update (id, data) {
    return client.patch('/reels/' + id, data.prepareForSend())
  },
  saveArchiveWeb (id) {
    return client.get('/reels-save-archive-web/' + id)
  },
  delete (id) {
    return client.delete('/reels/' + id)
  },
  search (data, query) {
    return client.get('/reels', {
      params: {
        filter: JSON.stringify(data),
        include: 'fund',
        limit: query.limit,
        ascending: query.ascending,
        page: query.page,
        byColumn: query.byColumn,
        orderBy: query.orderBy
      }
    })
  },
  deleteImage (reelId, imageId) {
    return client.delete('/reels/' + reelId + '/reelimage/' + imageId)
  },
  deleteRestorationImage (restorationId, imageId) {
    return client.delete('/restorations/' + restorationId + '/restorationimage/' + imageId)
  }
}



// WEBPACK FOOTER //
// ./src/api/reels.js